module.exports = __webpack_public_path__ + "img/139820.2c1894d4.png";